import { GOOGLE_API_KEY } from '../../constants/Misc';
import { END_POINT } from '../../constants/EndPoints';
import { fetchMiddleware } from '../MiddlewareActions';
/**
 *
 * @param {any} address
 * @param {any} cb
 *    return position as { lat, lng }
 */
export const findPositionByAddress = (address, cb, dispatch, getState) => {
  // Call the server thunk via dispatch
  dispatch(findPositionByAddressServer(address, (position) => {
    if (position != null) {
      cb(position);
      console.log('server found');
    } else {
      // Fallback to Google
      findPositionByAddressGoogle(address, (position) => {
        if (position != null) {
          cb(position);
          console.log('google found');
        } else {
          // Fallback to OSM
          findPositionByAddressOSM(address, cb);
          console.log('osm fallback');
        }
      });
    }
  }));
};

export const findAddressByPosition = (coordinate, language, cb) => {
  findAddressByPositionGoogle(coordinate, language, (address) => {
    if (address != null) {
      cb(address);
    } else {
      // if failed - get address from OSM:
      findAddressByPositionOSM(coordinate, language, cb);
    }
  })
}

// ##################################################
// ##########      Private methods:        ##########
// ##################################################

const fetchInternal = (path) => {
  return fetch(path).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      return null;
    }
  });
}

const findPositionByAddressServer = (address, cb) => {
  return (dispatch, getState) => {
    const request = `${END_POINT}/address/geocode/google?address=${address}`;
    console.log('server request started');

    fetchMiddleware(request, {}, getState)
      .then(json => {
        let positionResult = null;

        if (json && json.data.lat != null && json.data.lng != null) {
          positionResult = { lat: json.data.lat, lng: json.data.lng };
        }

        cb(positionResult);
      })
      .catch(err => {
        console.error("server geocoding error:", err);
        cb(null);
      });
  };
};
const findPositionByAddressGoogle = (address, cb) => {
  const request = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=' + GOOGLE_API_KEY;
  fetchInternal(request).then(json => {
    let positionResult = null;
    if (json.status == 'OK') {
      positionResult = json.results[0].geometry.location;
    }
    cb(positionResult);
  });
}

const findPositionByAddressOSM = (address, cb) => {
  let params = [
    {
      key: 'q',
      value: address,
    },
    {
      key: 'format',
      value: 'json',
    },
    {
      key: 'limit',
      value: 1,
    },
    {
      key: 'addressdetails',
      value: 1,
    },
  ];
  let paramsQuery = '';
  params.forEach((param, index) => {
    const firstChar = (index == 0) ? '?' : '&';
    paramsQuery += (firstChar + param.key + '=' + param.value);
  });
  const request = 'https://nominatim.openstreetmap.org/search' + paramsQuery;
  return fetchInternal(request).then(json => {
    let positionResult = null;
    if (json != null && json[0] != null) {
      positionResult = {
        lat: parseFloat(json[0].lat),
        lng: parseFloat(json[0].lon)
      }
    }
    cb(positionResult);
  });
}

const findAddressByPositionGoogle = (coordinates, language, cb) => {
  const latLngStr = coordinates.Latitude + ',' + coordinates.Longitude;
  const url = END_POINT + `/geoocde?latlng=${latLngStr}&language=${language}`;



  const request = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latLngStr + '&language=' + language + '&key=' + GOOGLE_API_KEY;
  return fetchInternal(request).then(json => {
    let address = null;
    if (json.status == 'OK') {

      const { results } = json;
      address = {
        FormattedAddress: results[0].formatted_address
      };

      results.forEach((result) => {
        const addressComponent = result.address_components;
        if (address.City == null) {
          const city = addressComponent.find((item) => { return item.types.indexOf('locality') != -1 });
          address.City = (city == null) ? null : city.long_name;
        }
        if (address.CityDistrict == null) {
          const cityDistrict = addressComponent.find((item) => { return item.types.indexOf('sublocality') != -1 });
          address.cityDistrict = (cityDistrict == null) ? null : cityDistrict.long_name;
        }
        if (address.Country == null || address.CountryCode == null) {
          const country = addressComponent.find((item) => { return item.types.indexOf('country') != -1 });
          address.Country = (country == null) ? null : country.long_name;
          address.CountryCode = (country == null) ? null : country.short_name;
        }
        if (address.HouseNumber == null) {
          const houseNumber = addressComponent.find((item) => { return item.types.indexOf('street_number') != -1 });
          address.HouseNumber = (houseNumber == null) ? null : houseNumber.long_name;
        }
        if (address.Street == null) {
          const street = addressComponent.find((item) => { return item.types.indexOf('route') != -1 });
          address.Street = (street == null) ? null : street.long_name;
        }
        if (address.State == null) {
          const state = addressComponent.find((item) => { return item.types.indexOf('administrative_area_level_1') != -1 });
          address.State = (state == null) ? null : state.long_name;
        }
        if (address.PostalCode == null) {
          const postalCode = addressComponent.find((item) => { return item.types.indexOf('postal_code') != -1 });
          address.PostalCode = (postalCode == null) ? null : postalCode.long_name;
        }
      });

      cb(address);
    } else {
      // console.log('Geocode was not successful for the following reason: ' + json.data);
      cb(null);
    }
  });
}

const findAddressByPositionOSM = (coordinates, language, cb) => {
  let params = [
    {
      key: 'format',
      value: 'json',
    },
    {
      key: 'lat',
      value: coordinates.Latitude,
    },
    {
      key: 'lon',
      value: coordinates.Longitude,
    },
    {
      key: 'accept-language',
      value: language,
    },
    {
      key: 'zoom',
      value: 18,
    },
    {
      key: 'addressdetails',
      value: 1,
    },
  ];
  let paramsQuery = '';
  params.forEach((param, index) => {
    const firstChar = (index == 0) ? '?' : '&';
    paramsQuery += (firstChar + param.key + '=' + param.value);
  });
  const request = 'https://nominatim.openstreetmap.org/reverse' + paramsQuery;
  return fetchInternal(request).then(json => {
    let address = null;
    const addressDetails = json.address;
    if (addressDetails != null) {
      address = {
        City: addressDetails.city,
        CityDistrict: addressDetails.city_district || addressDetails.suburb,
        Country: addressDetails.country,
        CountryCode: addressDetails.country_code,
        HouseNumber: addressDetails.house_number,
        Street: addressDetails.road,
        PostalCode: addressDetails.postcode,
        State: addressDetails.state,
        FormattedAddress: json.display_name,
      };
    }

    cb(address);
  });
}
